import {post} from "./utils";
import {ParserConfig} from "./config";

export interface ParsedField {
    error: string
    is_valid: boolean
    value: string
    value_from_dom: string
}

export interface ParsedItem {
    is_valid: boolean
    fields: Record<string, ParsedField>
}

export interface ParseResponse {
    items: ParsedItem[]
    config: ParserConfig
    config_modified: boolean
}

export async function parseHTML(url: string, config: ParserConfig, proxy: string): Promise<ParseResponse> {
    const resp = await post<{}, any>("/api/parse", {
        url: url,
        config: config,
        proxy: proxy
    })

    return {
        items: resp.items,
        config: resp.config,
        config_modified: resp.config_modified
    }
}
